import { createFileRoute } from '@tanstack/react-router';
import { WorkflowsPage } from '@/features/tasks/admin/WorkflowsPage';

/**
 * Flussi di lavorazione dei task — `BE-RESPONSE-TO-FE-TASK-WORKFLOW-AND-HIERARCHY-v1` (task 1400).
 *
 * Stati con la loro categoria, transizioni con le loro condizioni, validazione del grafo e
 * assegnazione ai gruppi. Un flusso nasce **disattivato**: l'attivazione è il momento in cui il
 * server controlla il grafo, ed è un bottone che può fallire.
 */
export const Route = createFileRoute('/_app/admin/workflows')({ component: WorkflowsPage });
